import { render, staticRenderFns } from "./LangButton.vue?vue&type=template&id=3c03ba8f&scoped=true&"
import script from "./LangButton.vue?vue&type=script&lang=ts&"
export * from "./LangButton.vue?vue&type=script&lang=ts&"
import style0 from "./LangButton.vue?vue&type=style&index=0&id=3c03ba8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c03ba8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VListItemContent,VMenu})
